import { render, staticRenderFns } from "./ProjectSkill.vue?vue&type=template&id=5272253d&"
import script from "./ProjectSkill.vue?vue&type=script&lang=js&"
export * from "./ProjectSkill.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSkill.vue?vue&type=style&index=0&id=5272253d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports